<template>
  <div>
    <b-card title="Warehouse Reports">
      <b-row>
        <b-col
          cols="12"
          lg="6"
          class="my-1 align-items-start"
        >
          <v-select
            v-model="selectedReport"
            :reduce="option => option.key"
            label="name"
            placeholder="Select Required Report"
            :options="filteredOptions"
          />
        </b-col>
      </b-row>
    </b-card>
    <div v-if="selectedReport === 'temporary_warehouse_report_key'">
      <TemporaryWarehouseReport />
    </div>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import TemporaryWarehouseReport from './TemporaryWarehouseReport/TemporaryWarehouseReport.vue'

export default {
  components: {
    TemporaryWarehouseReport,
    BCard,
    BRow,
    BCol,
    vSelect,
  },
  data() {
    return {
      selectedReport: '',
      reportOptions: [
        {
          name: 'Temporary Warehouse Report', component: 'TemporaryWarehouseReport', key: 'temporary_warehouse_report_key', permission: 'temporary-warehouse-report',
        },
      ],
    }
  },
  computed: {
    filteredOptions() {
      return this.reportOptions.filter(option => this.hasPermission(option.permission))
    },
  },
  methods: {
    hasPermission(permission) {
      return this.$store.getters.permissions.includes(permission)
    },
  },
}
</script>
<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select';

</style>
